import React, { useRef, useState, useEffect } from 'react';
import BracketBox from '../../extra/BracketBox';

const SpotZoom = ({ image }) => {
  const imageRef = useRef(null);
  const lensRef = useRef(null);
  const containRef = useRef(null);

  return (
    <div
      ref={containRef}
      style={{
        position: 'relative',
        display: 'inline-block',
        margin: 10,
        cursor: 'zoom-in',
        display: 'flex',
        justifyContent: 'center'
      }}
    >
      <img

        src={image}
        alt="Zoom"
        ref={imageRef}
        style={{
          display: 'block',
          height: "calc(100vh - 60px)",
          borderRadius: 4,
          margin: 'auto'
        }}
      />
      <BracketBox
        key={image}
        containRef={containRef}
        imageRef={imageRef}
        color="#fbe324"
        lensSize={400}
        lensVisible={true}
      />
    </div>
  );
};

export default SpotZoom;
